<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data PartPurchaseQualityControlConfirmationDetail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="input-" size="sm" :model.sync="model.controlCardId" :isRequired="true" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" />
				<app-input-textbox id="fieldset-thickness" label-cols-lg="12" label="Thickness" label-for="input-thickness" size="sm" :model.sync="model.thickness"  />
				<app-input-textbox id="fieldset-width" label-cols-lg="12" label="Width" label-for="input-width" size="sm" :model.sync="model.width"  />
				<app-input-textbox id="fieldset-length" label-cols-lg="12" label="Length" label-for="input-length" size="sm" :model.sync="model.length"  />
				<app-input-textbox id="fieldset-qty" label-cols-lg="12" label="Qty" label-for="input-qty" size="sm" :model.sync="model.qty"  />
				<b-form-group id="fieldset-karat" label-cols-lg="12" label="Karat" label-for="input-karat">
						<b-form-checkbox id="input-karat" v-model="model.karat"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-retak" label-cols-lg="12" label="Retak" label-for="input-retak">
						<b-form-checkbox id="input-retak" v-model="model.retak"></b-form-checkbox>
					</b-form-group>
					</b-col>
					<b-col cols="12" lg="6">
				<b-form-group id="fieldset-goresan" label-cols-lg="12" label="Goresan" label-for="input-goresan">
						<b-form-checkbox id="input-goresan" v-model="model.goresan"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-gelombang" label-cols-lg="12" label="Gelombang" label-for="input-gelombang">
						<b-form-checkbox id="input-gelombang" v-model="model.gelombang"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-burry" label-cols-lg="12" label="Burry" label-for="input-burry">
						<b-form-checkbox id="input-burry" v-model="model.burry"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-benjolan" label-cols-lg="12" label="Benjolan" label-for="input-benjolan">
						<b-form-checkbox id="input-benjolan" v-model="model.benjolan"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-other-problem" label-cols-lg="12" label="Other Problem" label-for="input-other-problem">
						<b-form-checkbox id="input-other-problem" v-model="model.otherProblem"></b-form-checkbox>
					</b-form-group>
				<app-input-textarea id="fieldset-ng-information" label-cols-lg="12" label="Ng Information" label-for="input-ng-information" size="sm" :model.sync="model.ngInformation"  />
				<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Control Card Status" id="input-" size="sm" :model.sync="model.controlCardStatusId"   :selected="model.controlCardStatus != null ? model.controlCardStatus.name : ''" @input="getControlCardStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartPurchaseQualityControlConfirmationDetail from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetail';
import PartPurchaseQualityControlConfirmationDetailFilter from '@/filters/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetailFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PartPurchaseQualityControlConfirmation from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmation';
import PartPurchaseQualityControlConfirmationFilter from '@/filters/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		controlCardId: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				controlCardId: { required : "Control Card is Required."},
			},
			controlCards : [],
			controlCardStatuss : [],
			isBusy: false,
		}
	},
	methods : {
		getPartPurchaseQualityControlConfirmationDetail : async function(id) {
			this.isBusy = true;
			PartPurchaseQualityControlConfirmationDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getControlCards();
		//this.getControlCardStatuss();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartPurchaseQualityControlConfirmationDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getControlCards();
				this.getControlCardStatuss();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartPurchaseQualityControlConfirmationDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
